import { useEffect, useState } from "react";

import type { FormDocument } from "../../DocumentInput/useDocumentInput";
import { Pdf } from "../../Pdf/Pdf";

export function CommentFieldDocumentPreview({
  documents,
  onRemoveDocument,
}: {
  documents: FormDocument[];
  onRemoveDocument?: (document: FormDocument) => void;
}): React.ReactElement {
  const [fileUrl, setFileUrl] = useState<string | undefined>(undefined);
  const document = documents[0];
  useEffect(() => {
    if (!document) {
      setFileUrl(undefined);

      return;
    }
    let currFileUrl;
    if ("file" in document) {
      currFileUrl = URL.createObjectURL(document.file);
    } else {
      currFileUrl = document.url;
    }
    setFileUrl(currFileUrl);

    return () => {
      if (currFileUrl?.startsWith("blob:")) {
        URL.revokeObjectURL(currFileUrl);
      }
    };
  }, [document]);
  const fileName = "file" in document ? document.file.name : document.fileName;
  let fileSize: number | undefined = undefined;
  if ("file" in document) {
    fileSize = document.file.size;
  } else if ("fileSize" in document) {
    fileSize = document.fileSize as number;
  }

  return (
    <div data-testid="comment-attachment-document-preview">
      <Pdf
        onClick={() => window.open(fileUrl, "_blank")}
        onDelete={() => onRemoveDocument && onRemoveDocument(document)}
        {...{
          fileName,
          fileSize,
        }}
      />
    </div>
  );
}
